 
export enum SpacePermissions {
  PROTOCOLS_READ = 'space.protocols.read',
  PROTOCOLS_EDIT = 'space.protocols.edit',
  PROTOCOLS_DELETE = 'space.protocols.delete',
  TASKS_READ = 'space.tasks.read',
  TASKS_EDIT = 'space.tasks.edit',
  TASKS_DELETE = 'space.tasks.delete',
  ADMIN = 'space.admin'
}

export default SpacePermissions
